module.exports = __webpack_public_path__ + "static/img/menu.8ca8221e.png";